/**
 * Resource Kiểm kê quỹ tiền mặt
 * NXHung 11.06.2024
 */
export default {
  Title: 'Kiểm kê quỹ tiền mặt',
  DetailTitle: 'Bảng kiểm kê quỹ',
  VoucherRef: 'CT tham chiếu',
  VoucherRefTitle: 'Chứng từ tham chiếu',
  State: 'Trạng thái xử lý',
  InventoryToDate: 'Kiểm kê đến ngày',
  FundInventoryDate: 'Ngày kiểm kê',
  FundInventoryNoLabel: 'Số',
  FundInventoryDateLabel: 'Ngày',
  FundInventoryTimeLabel: 'Giờ',
};
